import { client } from './client'

export default {
  get () {
    return client.get('/profile')
  },
  update (data) {
    return client.post('/profile/update', data)
  },
  password (data) {
    return client.post('/profile/password', {
      password: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/profile.js